const DB_NAME = 'FamilyManagerDB';
const STORE_NAME = 'familyData';

export const saveLocalData = (data) => {
    localStorage.setItem('szno_family_data', JSON.stringify({
        data,
        timestamp: Date.now()
    }));
};

export const getLocalData = () => {
    const stored = localStorage.getItem('szno_family_data');
    if (!stored) return null;
    try {
        return JSON.parse(stored);
    } catch (e) {
        return null;
    }
};

export const saveFamilySecret = (secret) => {
    sessionStorage.setItem('szno_family_secret', secret);
};

export const getFamilySecret = () => {
    return sessionStorage.getItem('szno_family_secret');
};

export const clearFamilySecret = () => {
    sessionStorage.removeItem('szno_family_secret');
};
